import {
    GET_ORDER_START,
    GET_ORDER_SUCCESS,
    GET_ORDER_ERROR
} from '../../constants';
import { change } from 'redux-form';
import { getOrder as query } from '../../lib/graphql';
import { setLoaderComplete, setLoaderStart } from '../loader/loader';
import showToaster from '../../helpers/toastrMessgaes/showToaster';
import { closeHeaderModal } from '../siteadmin/modalActions';

export function getOrderAction({ promoId, isPromoIdRemove }) {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: GET_ORDER_START,
            });
            if (!navigator.onLine) {
                showToaster({ messageId: 'networkFailed', toasterType: 'error' })
                return;
            }

            dispatch(setLoaderStart('applyPromo'));

            const { data } = await client.query({
                query,
                variables: {
                    promoId: promoId ? promoId : null,
                    isPromoIdRemove
                },
                fetchPolicy: 'network-only'
            })

            if (data?.getOrder?.status === 200) {
                dispatch(setLoaderComplete('applyPromo'));
                dispatch(closeHeaderModal('promoCodeModal'));

                if (isPromoIdRemove) {
                    await dispatch(change("PromoCodeForm", 'promoCode', null));
                    await dispatch(change("PromoCodeForm", 'promoId', null));
                    await dispatch(change("PromoCodeForm", "isPromoIdRemove", true))
                }
                dispatch({
                    type: GET_ORDER_SUCCESS,
                });
            } else {
                dispatch(setLoaderComplete('applyPromo'));
                let errorMessage = data?.getOrder?.errorMessage
                await showToaster({ messageId: 'errorMessage', toasterType: 'error', requestContent: errorMessage })
                dispatch({ type: GET_ORDER_ERROR });
            }
        } catch (error) {
            dispatch(setLoaderComplete('applyPromo'));
            dispatch({
                type: GET_ORDER_ERROR,
                payload: {
                    error,
                },
            });
            return false;
        }
        return true;
    };
}